<template>
  <div>
    <div style="width:1000px">
      <el-form
        ref="form"
        label-width="120px"
      >
        <el-form-item>
          <el-button
            size="small"
            @click="downTemplate()"
          >
            1.下载模板
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-upload
            ref="uploadExcel"
            v-model="form.filePath"
            :action="uploadUrl"
            :on-success="handleSuccess"
            :on-error="handleError"
            accept=".xls,.xlsx"
            multiple
            :limit="1"
            :headers="headers"
            :on-exceed="handleExceed"
            :before-upload="beforeUploadFile"
            :before-remove="beforeRemove"
            :on-remove="onRemove"
            :file-list="fileList"
          >
            <el-button
              size="small"
              plain
            >
              2.选择文件
            </el-button>
            <div
              slot="tip"
              class="el-upload__tip"
            >
              只能上传1个模板文件(excel)，且不超过10M
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <el-button @click="uploadFileView()">
            3.预览数据
          </el-button>
          <el-button
            type="primary"
            :disabled="isDisable"
            @click="sourceRelease()"
          >
            4.导入数据
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="500"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
    >
      <vxe-table-column
        field="linkMan"
        title="车队名称"
        min-width="120"
      />
      <vxe-table-column
        field="name"
        title="联系人"
        min-width="120"
      />
      <vxe-table-column
        field="phone"
        title="联系方式"
        min-width="120"
      />
      <vxe-table-column
        field="password"
        title="密码"
        min-width="150"
      />
      <vxe-table-column
        field="identificationNumber"
        title="身份证号"
        min-width="180"
      />
      <vxe-table-column
        field="idCardDueDateStr"
        title="身份证有效期"
        min-width="120"
      />
      <vxe-table-column
        field="provinceStr"
        title="省"
        min-width="160"
      />
      <vxe-table-column
        field="cityStr"
        title="市"
        min-width="130"
      />
      <vxe-table-column
        field="countyStr"
        title="区/县"
        min-width="150"
      />
      <vxe-table-column
        field="homeAddress"
        title="详细地址"
        min-width="150"
      />
      <vxe-table-column
        field="businessLicenseNumber"
        title="统一社会信用代码"
        min-width="150"
      />
      <vxe-table-column
        field="legalPerson"
        title="法人代表名称"
        min-width="150"
      />
      <vxe-table-column
        field="workCompany"
        title="工作单位"
        min-width="150"
      />
      <vxe-table-column
        field="roadPermitNumber"
        title="道路运输经营许可证号"
        min-width="180"
      />
      <vxe-table-column
        field="isShareStr"
        title="是否清分"
        min-width="150"
      />
      <vxe-table-column
        field="shareRatio"
        title="清分比率(%)"
        min-width="150"
      />
    </vxe-table>
  </div>
</template>
<script>
import request from "@/utils/request";
import { getToken } from '@/utils/auth';
export default {
  data() {
    return {
      isDisable: false,
      fileList: [],
      uploadUrl: this.BASE_API_URL + "ntocc-tps-api/fileUpload",
      tableData: [],
      headers:{
        Authorization:'Bearer ' + getToken(),
        deviceId:'0000000000'
      },
      form: {
        filePath: "",
        isView: "2",
        type:"1",
        teamCode:"",
      }
    };
  },
  created() {
  },

  methods: {
    init() {
      this.isDisable = false
      this.form.isView = 2;
      this.tableData = [];
      this.form.filePath = "";
      this.$refs.uploadExcel.clearFiles()
    },
    //上传文件预览
    uploadFileView() {
      if ("" == this.form.filePath) {
        return this.$message.warning("请先上传文件");
      }
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-basic-api/driver/driverImportView`,
        params: { filePath: this.form.filePath , type: this.form.type},
        method: "post"
      }).then(
        response => {
        rLoading.close();
        this.tableData = response.data;
        this.$message({ message: response.msg, type: "success" });
        this.form.isView = 1;
      });
    },
    downTemplate() {
      request({
        url: `/ntocc-basic-api/driver/downTemplate`,
        params:{type: this.form.type},
        method: "get"
      }).then(response => {
        window.open(response.data);
      });
    },
    //发布货源
    sourceRelease() {
      if ("" == this.form.filePath) {
        return this.$message.warning("请先上传文件");
      }
      if (1 != this.form.isView) {
        return this.$message.warning(
          "请先预览后，再导入数据，并且不能重复导入"
        );
      }
      this.isDisable = true;
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-basic-api/driver/driverImport`,
        params: { filePath: this.form.filePath, isView: this.form.isView , type: this.form.type, teamCode: this.form.teamCode},
        method: "post"
      }).then(response => {
        this.$message({ message: response.msg, type: "success" });
        this.form.isView = 2;
        this.isDisable = false;
        rLoading.close();
      });
    },
    // 上传成功回调
    handleSuccess(res, file) {
      if(res.status==500){
        this.$message.error(res.msg)
      } else {
        this.$message({ message: res.msg, type: "success" });
        this.form.filePath = res.data;
      }
    },
    //上传前校验
    beforeUploadFile(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== "xls" && extension !== "xlsx") {
        this.$message.error("只能上传excel文件");
        return false;
      }
      if (size > 10) {
        this.$message.error("上传文件大小不能超过 10MB!");
        return false;
      }
      // 获取token值，实时获取
      this.headers.Authorization = 'Bearer ' + getToken()
      return true
    },

    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: "错误",
        message: `文件上传失败`
      });
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    onRemove(file, fileList) {
      this.form.isView = 2;
      this.tableData = [];
      this.form.filePath = "";
      this.isDisable = false;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    }
  }
};
</script>
<style>
</style>
